import React from "react";
import SearchBar from "@/shared/components/ui/SearchBar/SearchBar";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { Trash2 } from "lucide-react";

const CampaignHeader = ({
  searchValue,
  setSearchValue,
  onSearchChange,
  isLoading,
  handleNewCampaign,
  hasSearchOrFilters,
  selectedCount,
  onDeleteClick,
  onClearSelection,
}) => {
  return (
    <div className="flex w-full justify-between items-center">
      <SearchBar
        value={searchValue}
        setFilterValue={setSearchValue}
        onChange={onSearchChange}
        placeholder="Search from added list of campaigns"
        disabled={isLoading && !hasSearchOrFilters}
        className="w-[270px]"
      />

      <div className="flex items-center gap-2">
        {selectedCount > 1 && (
          <>
            <SecondaryButton
              title={`Delete ${selectedCount}`}
              icon={<Trash2 size={16} className="text-error-500" />}
              onClick={onDeleteClick}
              className="shadow-none border-error-500 text-error-500"
            />

            <SecondaryButton
              title="Clear Selection"
              onClick={onClearSelection}
              className="shadow-none"
            />
          </>
        )}
        <PrimaryButton onClick={handleNewCampaign}>New Campaign</PrimaryButton>
      </div>
    </div>
  );
};

export default CampaignHeader;
